import React from 'react';
import { Card, Row, Col, Progress, Empty, Divider } from 'antd';

const EstimateStatusBreakdown = ({ data, loading }) => {
  if (loading || !data || !data.estimates) {
    return null;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  };

  // Filter out statuses with no estimates
  const activeStatuses = data.estimates.statuses.filter((status) => status.count > 0);
  const monthlyData = data.estimates.by_month || [];

  if (activeStatuses.length === 0 && monthlyData.length === 0) {
    return (
      <Card title="Estimate Breakdown" style={{ marginBottom: 24 }}>
        <Empty description="No estimates yet" />
      </Card>
    );
  }

  // Calculate total for percentage
  const totalValue = activeStatuses.reduce((sum, status) => sum + status.total, 0);

  return (
    <Card title="Estimate Breakdown" style={{ marginBottom: 24 }}>
      {activeStatuses.length > 0 && (
        <div>
          <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Status</h3>
          <Row gutter={[16, 16]}>
            {activeStatuses.map((status) => {
              const percentage = totalValue > 0 ? (status.total / totalValue) * 100 : 0;
              
              return (
                <Col xs={24} sm={12} lg={12} xl={8} key={status.key}>
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
                      <span style={{ fontWeight: 500, marginRight: 8 }}>{status.title}</span>
                      <span style={{ color: '#666', whiteSpace: 'nowrap' }}>{status.count}</span>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontSize: 18, fontWeight: 'bold', color: status.color }}>
                        {formatCurrency(status.total)}
                      </div>
                    </div>
                    <Progress
                      percent={Math.round(percentage)}
                      strokeColor={status.color}
                      showInfo={false}
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      )}

      {monthlyData.length > 0 && (
        <div>
          <Divider />
          <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Month (Last 12 Months)</h3>
          <Row gutter={[16, 16]}>
            {monthlyData.map((month, index) => (
              <Col xs={12} sm={8} lg={6} xl={4} key={index}>
                <Card
                  size="small"
                  style={{
                    textAlign: 'center',
                    borderTop: '2px solid #fa8c16',
                  }}
                >
                  <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 4 }}>
                    {month.month}
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 'bold', color: '#fa8c16' }}>
                    {month.count}
                  </div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                    {formatCurrency(month.value)}
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </Card>
  );
};

export default EstimateStatusBreakdown;
